import React from 'react';

import { IsDisabled } from '../../../../../types';

import { ThreeDStockProductsSearchField } from '../../helpers/ThreeDStockProductsSearchField';
import { ThreeDStockLifestylesSearchField } from '../../helpers/ThreeDStockLifestylesSearchField';
import { ThreeDStockMaterialsSearchField } from '../../helpers/ThreeDStockMaterialsSearchField';
import { PureIconButtonHelper } from '../../../../../helpers/buttons/PureIconButtonHelper';

import { StockTabs } from '../../../stockConstants';
import { IconsEnum } from '../../../../../assets/icons/types';
import { categoriesKeys } from '../../../../../locales/keys';

interface ThreeDStockModalHeaderProps {
  tab?: StockTabs;
  withSuggestInput?: boolean;
  withSimilarImageFilter?: boolean;
  withSimilarInImageFilter?: boolean;
  value?: string;
  onSearch?: (value?: string) => void;
  onSearchSimilarImage?: (imageUrl: string) => void;
  onSearchInImage?: (imageUrl: string) => void;
  disabled?: IsDisabled;
  onCategoriesClick: () => void;
}

function ThreeDStockModalHeader({
  tab,
  withSuggestInput,
  withSimilarImageFilter,
  withSimilarInImageFilter,
  value,
  onSearch,
  onSearchSimilarImage,
  onSearchInImage,
  disabled,
  onCategoriesClick
}: ThreeDStockModalHeaderProps) {
  return (
    <div className="flex h-16 sm:px-4 gap-2 border-b dark:border-gray-700 bg-white dark:bg-gray-900">
      <PureIconButtonHelper
        className="py-2 pl-2 pr-2 sm:pr-4 sm:space-x-1 rounded-md inline-flex items-center whitespace-nowrap text-sm font-medium leading-6 focus:ring-base hover:text-gray-950 dark:hover:text-white hover:bg-gray-200 dark:hover:bg-gray-700 focus:ring-offset-0 transition-colors duration-150 ease-out"
        i18nTextClassName="text-lg sr-only sm:not-sr-only"
        icon={IconsEnum.MENU_SOLID}
        iconClassName="h-6 w-6 p-0.5"
        i18nText={categoriesKeys.plural}
        onClick={onCategoriesClick}
      />

      {tab === StockTabs.PRODUCTS && (
        <ThreeDStockProductsSearchField
          withSuggestInput={withSuggestInput}
          withSimilarImageFilter={withSimilarImageFilter}
          withSimilarInImageFilter={withSimilarInImageFilter}
          value={value}
          onSearch={onSearch}
          onSearchSimilarImage={onSearchSimilarImage}
          onSearchInImage={onSearchInImage}
          disabled={disabled}
        />
      )}

      {tab === StockTabs.LIFESTYLES && (
        <ThreeDStockLifestylesSearchField
          withSimilarImageFilter={withSimilarImageFilter}
          value={value}
          onSearch={onSearch}
          onSearchSimilarImage={onSearchSimilarImage}
          disabled={disabled}
        />
      )}

      {tab === StockTabs.MATERIALS && (
        <ThreeDStockMaterialsSearchField
          value={value}
          onSearch={onSearch}
          disabled={disabled}
        />
      )}
    </div>
  );
}

export default ThreeDStockModalHeader;
